import { Injectable } from '@angular/core';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';
import { DocumentRetention } from '../models/document-retention';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor(
    private http: JsonHttpService) {
  }

  getDocumentRetentions(): Promise<DocumentRetention[]> {
    return this.http.get('/api/maintenance/get-document-retentions').toPromise();
  }

  saveDocumentRetention(retention: DocumentRetention): Promise<DocumentRetention> {
    return this.http.post('/api/maintenance/save-document-retention', retention, null, false).toPromise();
  }

  deleteDocumentRetention(documentRetentionId: number): Promise<void> {
    const options = { params: new HttpParams().set('id', documentRetentionId.toString()) };
    return this.http.post('/api/maintenance/delete-document-retention', null, options).toPromise();
  }
}
